import app from 'flarum/forum/app';

/** This extension's forum strings, by the part of the key after `forum.`. */
export const t = (k, p) => app.translator.trans('ernestdefoe-docket.forum.' + k, p);